import { useContext, useEffect } from 'react';
import { CoreContext } from '../context/index.js';
import logger from '../utils/logger.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-5CMab_Gs.js';
import '../utils/currency.js';
import 'lodash/get';
import '../utils/price.js';
import '../product-_pRduMz7.js';
import 'next/server';
import '../index-Oip0gjfj.js';
import 'next/router';
import '../helpers-qyZpLI0y.js';
import 'lodash';
import '../index-QrdBfapu.js';
import { c as trackBasket } from '../kwkUni-2OQfB-dG.js';
import '../utils/logToSlack.js';
import 'number-currency-format';
import '../utils/product.js';
import '../paths-ZKN3m62_.js';
import '../cookies-l-jEMp6P.js';

const useAccorBasketTracking = ({ cart, force }) => {
    var _a, _b;
    const { data: { siteConfig: { parentHotelCompany, accorAffiliateRetargetingEnabled: kwkEnabled = false }, }, } = useContext(CoreContext);
    // Early return if KWK tracking is disabled
    const shouldTrack = kwkEnabled && parentHotelCompany === 'Accor';
    useEffect(() => {
        var _a, _b, _c;
        // Track KWK basket view
        if (shouldTrack && ((_a = cart === null || cart === void 0 ? void 0 : cart.items) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const products = cart.items
                .filter(item => item &&
                item.product &&
                typeof item.product.sku === 'string' &&
                item.prices &&
                item.prices.price &&
                typeof item.prices.price.value === 'number' &&
                typeof item.quantity === 'number')
                .map(item => ({
                id: item.product.sku,
                price: item.prices.price.value,
                quantity: item.quantity,
            }));
            const currency = (_c = (_b = cart.prices) === null || _b === void 0 ? void 0 : _b.subtotal_including_tax) === null || _c === void 0 ? void 0 : _c.currency;
            if (!currency) {
                logger('[KWK] Missing currency on cart subtotal, skipping basket tracking', {
                    category: 'analytics',
                    type: 'error',
                });
                return;
            }
            trackBasket({
                products,
                currency,
                force,
            }).catch(err => {
                logger(`[KWK] Failed to track basket view: ${err}`, {
                    category: 'analytics',
                    type: 'error',
                });
            });
        }
    }, [cart.items, (_b = (_a = cart.prices) === null || _a === void 0 ? void 0 : _a.subtotal_including_tax) === null || _b === void 0 ? void 0 : _b.currency, shouldTrack]);
};

export { useAccorBasketTracking };
//# sourceMappingURL=useAccorBasketTracking.js.map
